import { render, staticRenderFns } from "./eventCloseClassifyGroup.vue?vue&type=template&id=38a190ed&scoped=true&"
import script from "./eventCloseClassifyGroup.vue?vue&type=script&lang=js&"
export * from "./eventCloseClassifyGroup.vue?vue&type=script&lang=js&"
import style0 from "./eventCloseClassifyGroup.vue?vue&type=style&index=0&id=38a190ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a190ed",
  null
  
)

export default component.exports